import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { buildLinkYearsClassroom } from 'src/app/data/factory/link-years-classroom.factory';
import { ClassroomFilterDto } from 'src/app/data/models/dto/classroom-filter.dto';
import { LinkYearsClassrooms } from 'src/app/data/models/dto/link-years-classrooms';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';
import { UserUtil } from 'src/app/data/utils/user.utils';
import { FlatNode } from '../select-hierarquical-list/model/flat.node.interface';
import { SimpleNode } from '../select-hierarquical-list/model/simple.node.interface';

@Component({
  selector: 'app-link-year-classrooms',
  templateUrl: './link-year-classrooms.component.html',
  styleUrls: ['./link-year-classrooms.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class LinkYearClassroomsComponent implements OnInit {
  segmentTreeData: SimpleNode[] = [];
  selectedIdsClassrooms: string[] = [];
  showClassroomsCombo: boolean = true;
  txtClassrooms: string = '';
  selectedYear: string = '';
  startTxtYear: string = '';
  idsSchool?: string[];

  constructor(
    private userUtil: UserUtil,
    private classroomsServive: ClassRoomsService,
    private dialog: MatDialogRef<LinkYearClassroomsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LinkYearsClassrooms
  ) {}

  async ngOnInit(): Promise<void> {
    this.idsSchool = this.userUtil.getSchools().map((school) => school.id);
    this.selectedYear = this.data.year;
    this.startTxtYear = this.data.year;
    this.selectedIdsClassrooms = this.data.idsClassrooms;
    this.txtClassrooms =
      this.data.idsClassrooms.length > 0 ? this.data.classrooms : '';
    if (this.data.year == '') {
      this.data.year = new Date().getFullYear().toString();
    }
    await this.loadSegmentTree(this.data.year);
    this.setTxtClassrooms();
  }

  private async loadSegmentTree(year: string): Promise<void> {
    const filter: ClassroomFilterDto = {
      year: year,
      idSchool: this.idsSchool![0],
    };
    const tree = await this.classroomsServive.getTree(filter).toPromise();
    this.segmentTreeData = tree.map((seg) => ({
      id: seg.id,
      name: seg.name,
      children: seg.series.map((ser) => ({
        name: ser.name,
        children: ser.classRooms.map((cls) => ({
          id: cls.id,
          name: cls.name,
        })),
      })),
    }));
  }

  private setTxtClassrooms() {
    let classroomsNames = '';
    this.segmentTreeData.forEach((segment) => {
      segment.children?.forEach((serie) => {
        serie.children?.forEach((classroom) => {
          if (this.selectedIdsClassrooms.includes(classroom.id!)) {
            classroomsNames = classroomsNames.concat(
              classroomsNames ? ', '.concat(classroom.name) : classroom.name
            );
          }
        });
      });
    });
    this.txtClassrooms = classroomsNames;
  }

  async getYearSelected(year: string) {
    this.txtClassrooms = '';
    this.selectedYear = year;
    this.segmentTreeData = [];
    await this.loadSegmentTree(year);
    this.setTxtClassrooms();
  }

  handleSelect(classrooms: FlatNode[]) {
    const ids = classrooms.map((classroom) => classroom.id);
    this.selectedIdsClassrooms = ids;
    const names = classrooms.map((classroom) => classroom.name);
    this.txtClassrooms = this.classroomsWithCommas(names);
  }

  private classroomsWithCommas(classrooms: string[]): string {
    let names = '';
    classrooms.forEach(async (classroom) => {
      if (names == '') {
        names = classroom.trim();
      } else {
        names = names + ', ' + classroom.trim();
      }
    });
    return names;
  }

  openList(evt: any, trigger: MatAutocompleteTrigger): void {
    evt.stopPropagation();
    if (trigger.panelOpen) {
      trigger.closePanel();
    } else {
      trigger.openPanel();
    }
  }

  closeComponent() {
    this.dialog.close();
  }

  saveComponent() {
    const result = buildLinkYearsClassroom(
      this.selectedYear,
      this.txtClassrooms,
      this.selectedIdsClassrooms
    );
    this.dialog.close(result);
  }
}
